// Auto-start any carousels on the page with a default configuration

const config = {
  advanceIntervalInSeconds: 5,
  transitionDurationInSeconds: 1,
  onSize: updateDescriptionDimensions,
};

const { CarouselSet } = window.carousels;

// Initialize carousels when the page is loaded
function startCarouselsOnPage() {
  const carouselElements = document.querySelectorAll(".carousel");
  if (carouselElements.length === 0) {
    return;
  }

  const carouselSet = new CarouselSet({
    ...config,
    carouselElements: Array.from(
      document.querySelectorAll(".carousel .slides")
    ),
    getFrameElements: (carouselElement) =>
      Array.from(carouselElement.querySelectorAll("figure")),
  });
  carouselSet.start();

  carouselElements.forEach((slide) => {
    slide.style.opacity = 1;
  });
}

function updateDescriptionDimensions({
  carouselElement,
  frameWidth,
  carouselVisibleWidth,
}) {
  // Padding should be 0 @ 600px, 80 @ 1100px and gradually increase in-between
  const padding = interpolateValueWithConstraints({
    lowX: 600,
    lowY: 0,
    highX: 1100,
    highY: 80,
    min: 0,
    max: 80,
    x: carouselVisibleWidth,
  });

  document.body.style.setProperty("--carousel-frame-width", `${frameWidth}px`);
  document.body.style.setProperty(
    "--carousel-visible-width",
    `${carouselVisibleWidth}px`
  );
  // This padding might be applied to the description in some cases, will be decided by CSS
  document.body.style.setProperty(
    "--carousel-suggested-padding",
    `${padding}px`
  );
}

document.addEventListener("DOMContentLoaded", startCarouselsOnPage);
